// src/pages/HomePage.js
import React, { useState } from "react"; // Added useState
import { Container, Row, Col, Button, Card, Modal } from "react-bootstrap"; // Added Modal
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import SideMenu from "./SideMenu";
import MemberMenu from "./MemberMenu";
import AdminMenu from "./AdminMenu";
import Logout from "./Logout";
import { useAuth } from "./Home1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRocket,
  faSignInAlt,
  faDollarSign,
  faPaperPlane,
  faCog,
  faLifeRing,
  faUsers,
  faBullhorn,
  faCalendarCheck,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

const HomePage = () => {
  const { user, isLoggedIn } = useAuth();
  const isAdmin = user?.id === "71";

  // --- State for Pricing Modal ---
  const [showPricingModal, setShowPricingModal] = useState(false);

  // --- Modal Handlers ---
  const handleClosePricingModal = () => setShowPricingModal(false);
  const handleShowPricingModal = () => setShowPricingModal(true);
  // -------------------------

  React.useEffect(() => {
    document.title = isLoggedIn
      ? "Dashboard - beaconSMS"
      : "Welcome - beaconSMS";
  }, [isLoggedIn]);

  return (
    <>
      <Container fluid='lg'>
        <Header user={user} />

        <Row className='mt-3 px-md-3'>
          {/* Conditional Side Menu */}
          {isLoggedIn && (
            <Col md='3' className='mb-3 mb-md-0'>
              {/* ... side menu content ... */}
              <Logout Menu='Login Menu' user={user?.username} />
              <SideMenu Menu="Member's Menu" menuu={MemberMenu} />
              {isAdmin && <SideMenu Menu="Admin's Menu" menuu={AdminMenu} />}
            </Col>
          )}

          <Col md={isLoggedIn ? 9 : 12} className='mt-3 mt-md-0'>
            {/* Welcome Card */}
            <Card className='shadow-sm mb-4 border-primary border-2'>
              {/* ... Welcome Card Content ... */}
              <Card.Body className='p-4 p-md-5'>
                {" "}
                <Card.Title
                  as='h2'
                  className='text-primary text-center fw-bold mb-3 display-5'
                >
                  {" "}
                  <FontAwesomeIcon icon={faRocket} className='me-3' /> Welcome
                  to beaconSMS!{" "}
                </Card.Title>{" "}
                <Card.Subtitle className='mb-4 text-muted text-center fs-5'>
                  {" "}
                  Your Reliable Partner for Exceptional Bulk SMS Services.{" "}
                </Card.Subtitle>{" "}
                <Card.Text className='text-center mb-0'>
                  {" "}
                  We are a dedicated technology provider specializing in
                  high-performance Mobile Messaging services and applications
                  globally. Reach your audience instantly and effectively.{" "}
                </Card.Text>{" "}
              </Card.Body>
            </Card>

            {/* Key Features Card */}
            <Card className='shadow-sm mb-4'>
              {/* ... Key Features Card Content ... */}
              <Card.Header className='bg-light fw-bold'>
                {" "}
                <FontAwesomeIcon
                  icon={faPaperPlane}
                  className='me-2 text-success'
                />{" "}
                Why Choose Us?{" "}
              </Card.Header>{" "}
              <Card.Body className='p-4'>
                {" "}
                <Row>
                  {" "}
                  <Col md={6} className='mb-3 mb-md-0'>
                    {" "}
                    <h6 className='fw-semibold'>
                      <i className='bi bi-check-circle-fill text-success me-2'></i>
                      High Delivery Rates
                    </h6>{" "}
                    <p className='small text-muted ms-4'>
                      Ensure your messages reach their destination with our
                      optimized routing and direct carrier connections.
                    </p>{" "}
                  </Col>{" "}
                  <Col md={6}>
                    {" "}
                    <h6 className='fw-semibold'>
                      <i className='bi bi-speedometer2 text-info me-2'></i>Fast
                      & Reliable
                    </h6>{" "}
                    <p className='small text-muted ms-4'>
                      Experience lightning-fast delivery speeds and a platform
                      built for reliability and uptime.
                    </p>{" "}
                  </Col>{" "}
                  <Col md={6} className='mt-md-3'>
                    {" "}
                    <h6 className='fw-semibold'>
                      <i className='bi bi-person-check-fill text-primary me-2'></i>
                      Easy-to-Use Platform
                    </h6>{" "}
                    <p className='small text-muted ms-4'>
                      Our intuitive interface makes composing and sending bulk
                      SMS simple and efficient.
                    </p>{" "}
                  </Col>{" "}
                  <Col md={6} className='mt-md-3'>
                    {" "}
                    <h6 className='fw-semibold'>
                      <i className='bi bi-currency-dollar text-warning me-2'></i>
                      Competitive Pricing
                    </h6>{" "}
                    <p className='small text-muted ms-4'>
                      Get great value with our transparent and affordable
                      pricing structure.
                    </p>{" "}
                  </Col>{" "}
                </Row>{" "}
              </Card.Body>
            </Card>

            {/* Getting Started Card */}
            <Card className='shadow-sm mb-4'>
              {/* ... Getting Started Card Content ... */}
              <Card.Header className='bg-light fw-bold'>
                {" "}
                <FontAwesomeIcon
                  icon={faSignInAlt}
                  className='me-2 text-info'
                />{" "}
                Getting Started{" "}
              </Card.Header>{" "}
              <Card.Body className='p-4 text-center'>
                {" "}
                <Card.Text className='mb-4'>
                  {" "}
                  Ready to send? It takes just a minute. Login to your existing
                  account or Register for a new one instantly.{" "}
                </Card.Text>{" "}
                <Button
                  as={Link}
                  to={isLoggedIn ? "/compose" : "/login"}
                  variant='primary'
                  size='lg'
                  className='px-5 py-3 shadow-sm rounded-pill fw-bold'
                  style={{ transition: "transform 0.2s ease-in-out" }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.transform = "scale(1.03)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  {" "}
                  {isLoggedIn ? "Go to Compose SMS" : "Login / Register"} »{" "}
                </Button>{" "}
              </Card.Body>
            </Card>

            {/* How It Works / Use Cases Card */}
            <Card className='shadow-sm mb-4'>
              {/* ... How It Works Card Content ... */}
              <Card.Header className='bg-light fw-bold'>
                {" "}
                <FontAwesomeIcon
                  icon={faCog}
                  className='me-2 text-secondary'
                />{" "}
                How It Works & Use Cases{" "}
              </Card.Header>{" "}
              <Card.Body className='p-4'>
                {" "}
                <Row>
                  {" "}
                  <Col md={6}>
                    {" "}
                    <h6 className='fw-semibold mb-3'>Simple Process:</h6>{" "}
                    <ol className='small ps-3 text-muted'>
                      {" "}
                      <li>Register or Log In to your account.</li>{" "}
                      <li>
                        Purchase SMS units via our secure payment options.
                      </li>{" "}
                      <li>
                        Compose your message and add recipients (paste, upload,
                        or use phonebook).
                      </li>{" "}
                      <li>
                        Specify your Sender ID (ensure it's registered for
                        specific networks like MTN NG).
                      </li>{" "}
                      <li>Send instantly or schedule for later!</li>{" "}
                    </ol>{" "}
                  </Col>{" "}
                  <Col md={6}>
                    {" "}
                    <h6 className='fw-semibold mb-3'>Popular Uses:</h6>{" "}
                    <ul className='small list-unstyled text-muted'>
                      {" "}
                      <li className='mb-1'>
                        <FontAwesomeIcon
                          icon={faBullhorn}
                          className='me-2 text-primary'
                        />{" "}
                        Marketing Campaigns & Promotions
                      </li>{" "}
                      <li className='mb-1'>
                        <FontAwesomeIcon
                          icon={faCalendarCheck}
                          className='me-2 text-success'
                        />{" "}
                        Event Invitations & Reminders
                      </li>{" "}
                      <li className='mb-1'>
                        <FontAwesomeIcon
                          icon={faInfoCircle}
                          className='me-2 text-info'
                        />{" "}
                        Customer Notifications & Alerts
                      </li>{" "}
                      <li className='mb-1'>
                        <FontAwesomeIcon
                          icon={faUsers}
                          className='me-2 text-warning'
                        />{" "}
                        Community / Group Announcements
                      </li>{" "}
                      <li className='mb-1'>
                        <i className='bi bi-shield-check text-danger me-2'></i>{" "}
                        OTP & Verification Codes
                      </li>{" "}
                    </ul>{" "}
                  </Col>{" "}
                </Row>{" "}
              </Card.Body>
            </Card>

            {/* Pricing & Support Card */}
            <Card className='shadow-sm mb-4'>
              <Card.Header className='bg-light fw-bold'>
                <FontAwesomeIcon
                  icon={faDollarSign}
                  className='me-2 text-warning'
                />{" "}
                Pricing & Support
              </Card.Header>
              <Card.Body className='p-4'>
                <Row>
                  <Col
                    md={6}
                    className='mb-3 mb-md-0 text-center text-md-start'
                  >
                    <h6 className='fw-semibold'>Purchase Units</h6>
                    <p className='small'>
                      Click below for our competitive rates and simple bank
                      deposit payment option.
                    </p>
                    {/* --- Updated Button to trigger modal --- */}
                    <Button
                      variant='outline-primary'
                      size='sm'
                      onClick={handleShowPricingModal} // Call handler to show modal
                    >
                      View Payment Details
                    </Button>
                    {/* --- End Updated Button --- */}
                  </Col>
                  <Col
                    md={6}
                    className='text-center text-md-start border-start-md'
                  >
                    <h6 className='fw-semibold'>Need Help?</h6>
                    <p className='small'>
                      Our support team is ready to assist you. Contact us via
                      phone for immediate help.
                    </p>
                    <p className='mb-0 fw-bold'>
                      <FontAwesomeIcon
                        icon={faLifeRing}
                        className='me-2 text-info'
                      />{" "}
                      SUPPORT: 2348083814362
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          {/* End Main Content Area */}
        </Row>
        <Footer />
      </Container>

      {/* --- Add the Pricing Modal --- */}
      <Modal show={showPricingModal} onHide={handleClosePricingModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon
              icon={faDollarSign}
              className='me-2 text-warning'
            />{" "}
            Buy SMS Online - Payment Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Replicated styling from previous Alert component */}
          <h5 className='text-center text-primary mb-3'>
            How to Buy SMS Units
          </h5>
          <hr />
          <p className='text-center mb-3 fw-bold fs-5'>
            {" "}
            {/* Emphasized Price */}
            PRICE PER UNIT : 2.50 NAIRA
          </p>
          <p className='text-center mb-2'>
            For Bank Deposits, please use your <strong>username</strong> as
            depositor's name.
          </p>
          {/* Use a div for better control over alignment and styling */}
          <div className='text-center mb-3'>
            {" "}
            {/* Center the block */}
            <div className='text-start d-inline-block p-3 border rounded bg-light shadow-sm'>
              {" "}
              {/* Inner styling */}
              <p className='mb-1'>
                <strong>BANK :</strong> GUARANTY TRUST BANK (NIGERIA)
              </p>
              <p className='mb-1'>
                <strong>CURRENCY :</strong> NAIRA
              </p>
              <p className='mb-1'>
                <strong>ACCOUNT NAME :</strong> E&L Tech Solutions Limited
              </p>
              <p className='mb-0'>
                <strong>ACCOUNT NUMBER :</strong> 0158543353
              </p>
            </div>
          </div>
          <p className='small text-muted text-center mb-3'>
            Units are credited automatically after payment confirmation.
          </p>
          <p className='small text-center mb-3'>
            For purchases above 1,000,000 units, please call our support lines
            or send us an email via our contact us page.
          </p>
          <p className='text-center mb-0 fw-bold'>
            <FontAwesomeIcon icon={faLifeRing} className='me-2 text-info' />{" "}
            HELP/SUPPORT : 2348083814362
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClosePricingModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* --- End Pricing Modal --- */}
    </>
  );
};

export default HomePage;
